var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90812 1.58332C9.34123 1.2717 8.65835 1.2717 8.09145 1.58332L2.80364 4.49001C2.18526 4.82993 1.7998 5.48785 1.7998 6.20344V11.7958C1.7998 12.5113 2.18526 13.1693 2.80364 13.5092L8.09145 16.4159C8.65835 16.7275 9.34123 16.7275 9.90812 16.4159L15.1959 13.5092C15.8143 13.1693 16.1998 12.5113 16.1998 11.7958V6.20344C16.1998 5.48785 15.8143 4.82993 15.1959 4.49001L9.90812 1.58332ZM8.45618 10.8514V11.9203H4.09463V6.16354H8.35178V7.23243H5.39038V8.48266H8.00572V9.51897H5.39038V10.8514H8.45618ZM14.154 11.9203L12.7459 11.92L11.664 10.3151L11.661 10.3153C11.6415 10.316 11.6229 10.3166 11.6033 10.3166H10.5532V9.25591H11.5314C11.9335 9.25591 12.234 9.16671 12.4327 8.98868C12.6307 8.81066 12.7304 8.57046 12.7304 8.25253C12.7304 7.9346 12.631 7.68774 12.4327 7.51231C12.2344 7.33688 11.9338 7.24915 11.5314 7.24915H10.5532V6.16362H11.6033C12.1072 6.16362 12.5418 6.2469 12.907 6.41455C13.2723 6.58185 13.5536 6.82131 13.7523 7.13405C13.951 7.44643 14.0499 7.82505 14.0499 8.25253C14.0499 8.68001 13.9506 9.04864 13.7523 9.35843C13.5536 9.66821 13.2718 9.90512 12.907 10.0698L12.9041 10.0711L12.9025 10.0718L12.901 10.0724L12.8986 10.0733L12.8958 10.0746L14.154 11.9203ZM8.82502 6.16362H10.0803V11.9203H8.82502V6.16362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr);
export default __webpack_public_path__ + "static/media/er.7d8d4fc21434d4e196782e7697e3510f.svg";
export { ForwardRef as ReactComponent };